import api from "../api";

const api_type = 'v1'

export const GetBaseApp = params => { return api.post(api_type+`/base/app`, params) }
export const GetBaseCountry = params => { return api.post(api_type+`/base/country`, params) }
export const GetBaseChannel = params => { return api.post(api_type+`/base/channel`, params) }

export const GetLogin = params => { return api.post(`/getLogin`, params) }
export const GetMenu = params => { return api.post(`/getMenu`, params) }

export const AddErrorData = params => { return api.post(api_type+`/error_data/add`, params) }
export const GetErrorDataPage = params => { return api.post(api_type+`/error_data/page`, params) }



// WEBPACK FOOTER //
// ./src/api/v1/base_info.js